import React, { useRef } from 'react';
import { motion } from 'framer-motion';
const videos = [{
  url: 'https://cdn.magicpatterns.com/uploads/cs5TdcgXgtae3rJcUL9R4s/IA inmo-2.mp4',
  type: 'Proyecto 3D'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/hFaej3v7VxNFXX5SVL2RZ2/IA inmo-1.mp4',
  type: 'Casa Terminada'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/agCNvjFFNZTfcFiBDww59b/IA inmo.mp4',
  type: 'Recorrido Virtual'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/xu9Htcvd7MQbnx4nEgJX6q/IA inmo-6.mp4',
  type: 'Interiorismo'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/6c7ZtBvPNBkKYeUtrkMbRV/IA inmo-5.mp4',
  type: 'Área Social'
}];
export function Features() {
  const scrollRef = useRef<HTMLDivElement>(null);
  return <section className="py-[64px] md:py-[96px] relative z-10 overflow-hidden bg-bg-secondary" data-id="element-81">
      <div className="container mx-auto px-5 max-w-[1100px]" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-12" data-id="element-83">
          <h2 className="text-[32px] md:text-[48px] font-[900] mb-4 uppercase text-white" data-id="element-84">
            MIRA LO QUE PODRÁS CREAR
          </h2>
          <p className="text-text-secondary text-[18px] font-[500]" data-id="element-85">
            Todos estos videos fueron generados con IA a partir de simples fotos
            de propiedades.
          </p>
        </motion.div>

        <div ref={scrollRef} className="flex gap-[24px] overflow-x-auto snap-x snap-mandatory pb-8 scrollbar-hide -mx-5 px-5 md:mx-0 md:px-0" data-id="element-86">
          {videos.map((video, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.5,
          ease: [0.16, 1, 0.3, 1]
        }} className="min-w-[280px] md:min-w-[320px] snap-center bg-bg-card border border-border-card rounded-[16px] p-4 group hover:border-accent-border hover:shadow-[0_12px_40px_rgba(0,180,230,0.1)] hover:-translate-y-[6px] transition-all duration-250 flex-shrink-0" data-id="element-87">
              <div className="aspect-[9/16] bg-bg-primary rounded-[8px] mb-4 relative overflow-hidden border border-border-subtle" data-id="element-88">
                <video src={video.url} autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity" data-id="element-89" />
              </div>
              <div className="flex justify-center" data-id="element-90">
                <span className="inline-block bg-accent-glow text-accent border border-accent-border rounded-[8px] px-3 py-1 text-[12px] font-bold uppercase" data-id="element-91">
                  ✦ {video.type}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}